// extracted by mini-css-extract-plugin
export default {"wrapper":"PayFail_wrapper__2VMI9"};